import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // eslint-disable-next-line no-console
  console.warn(
    "[supabase] REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY is missing. " +
      "Copy .env.example to .env.local and fill in your Supabase project values.",
  );
}

export const supabase = createClient(
  url ?? "https://placeholder.supabase.co",
  anonKey ?? "placeholder-anon-key",
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  },
);

export const isSupabaseConfigured = Boolean(url && anonKey);

export const GALLERY_BUCKET = "gallery";
export const GALLERY_TABLE = "gallery_images";
